export const SHIP_LEVELS = [
    { level: 1, health: 50, attack: 10, upgradeCost: 0, coinDrop: 10 },
    { level: 2, health: 75, attack: 15, upgradeCost: 100, coinDrop: 15 },
    { level: 3, health: 113, attack: 23, upgradeCost: 200, coinDrop: 20 },
    { level: 4, health: 170, attack: 34, upgradeCost: 400, coinDrop: 25 },
    { level: 5, health: 255, attack: 51, upgradeCost: 600, coinDrop: 30 },
    { level: 6, health: 383, attack: 77, upgradeCost: 1000, coinDrop: 35 },
    { level: 7, health: 575, attack: 115, upgradeCost: 1500, coinDrop: 40 },
    { level: 8, health: 863, attack: 173, upgradeCost: 2400, coinDrop: 45 },
    { level: 9, health: 1295, attack: 259, upgradeCost: 3200, coinDrop: 50 },
    { level: 10, health: 1943, attack: 389, upgradeCost: 5000, coinDrop: 55 }
];

export const PLAYER_MODEL_SEQUENCE = [
    'ship/ship-1-L1',
    'ship/ship-1-L2',
    'ship/ship-1-L3',
    'ship/ship-1-L4',
    'ship/ship-1-L5',
    'ship/ship-2-L6',
    'ship/ship-2-L7',
    'boat-speed-i',
    'ship-small',
    'ship-ocean-liner'
];

export const ENEMY_MODEL_SEQUENCE = [
    'ship/enemyship-L1',        // Level 1
    'ship/enemyship-1-L2',      // Level 2
    'ship/enemyship-1-L3',      // Level 3
    'ship/enemyship-1-L4',      // Level 4
    'ship/enemyship-1-L5',      // Level 5
    'ship/enemyship-1-L6',      // Level 6
    'ship/enemyship-1-L7',      // Level 7
    'ship/enemyship-1-L8',      // Level 8
    'ship/enemyship-1-L9',      // Level 9
    'ship/enemyship-1-L10'      // Level 10
];

export const LEVEL_CAP = SHIP_LEVELS.length;

export function clampLevel(level) {
    if (!Number.isFinite(level)) return 1;
    return Math.max(1, Math.min(LEVEL_CAP, Math.round(level)));
}

export function getLevelData(level) {
    const clamped = clampLevel(level);
    return SHIP_LEVELS[clamped - 1];
}

function pickModel(sequence, level) {
    const groupSize = Math.ceil(LEVEL_CAP / sequence.length);
    const index = Math.min(sequence.length - 1, Math.floor((clampLevel(level) - 1) / groupSize));
    return sequence[index];
}

export function getPlayerModelForLevel(level) {
    return pickModel(PLAYER_MODEL_SEQUENCE, level);
}

export function getEnemyModelForLevel(level) {
    return pickModel(ENEMY_MODEL_SEQUENCE, level);
}

export function getCoinDropForLevel(level) {
    return getLevelData(level).coinDrop;
}

export function getUpgradeCostForLevel(level) {
    return getLevelData(level).upgradeCost;
}
